import { API_CONFIG, MAIN_URL, REQUEST_URL } from "../../constant/ApplicationVariables";
import { axiosInstance } from "../useAxios/useAxios";

export const getConversationList_API = async (body) => {
    try {
        const response = await axiosInstance({
            url: MAIN_URL.url + REQUEST_URL.aiChatConversation,
            method: "POST",
            data: body,
            contentType: "application/json"
        });
        console.log(response, "getConversationList_API response");
        return response;
    } catch (error) {
        console.log(error, "getConversationList_API error");
        return error;
    }
}

export const saveGeneratedResponse_API = async (body) => {
    try {
        const response = await axiosInstance({
            url: MAIN_URL.url + REQUEST_URL.aiChatSave,
            method: "POST",
            data: body,
            contentType: "application/json"
        });
        console.log(response, "saveGeneratedResponse_API response");
        return response;
    } catch (error) {
        console.log(error, "saveGeneratedResponse_API error");
        return error;
    }
}

export const generateResponse_API = async (body) => {
    try {
        const response = await axiosInstance({
            url: MAIN_URL.url + REQUEST_URL.aiChatGenerate,
            method: "POST",
            data: body,
            contentType: "application/json",
            timeout: API_CONFIG.timeout
        });
        console.log(response, "generateResponse_API response");
        return response;
    } catch (error) {
        console.log(error, "generateResponse_API error");
        return error;
    }
}

export const getConversationHistoryList_API = async (body) => {
    try {
        const response = await axiosInstance({
            url: MAIN_URL.url + REQUEST_URL.aiChatHistory,
            method: "POST",
            data: body,
            contentType: "application/json"
        });
        console.log(response, "getConversationHistoryList_API response");
        return response;
    } catch (error) {
        console.log(error, "getConversationHistoryList_API error");
        return error;
    }
}

export const updateConversation_API = async (body) => {
    try {
        const response = await axiosInstance({
            url: MAIN_URL.url + REQUEST_URL.aiChatConversation, 
            method: "PUT", 
            data: body,
            contentType: "application/json"
        });
        console.log(response, "updateConversation_API response");
        return response;
    } catch (error) {
        console.log(error, "updateConversation_API error");
        return error;
    }
}

export const deleteConversation_API = async (body) => {
    try {
        const response = await axiosInstance({
            url: MAIN_URL.url + REQUEST_URL.aiChatConversation, 
            method: "PUT", 
            data: { ...body, isDelete: true },
            contentType: "application/json"
        });
        console.log(response, "deleteConversation_API response");
        return response;
    } catch (error) {
        console.log(error, "deleteConversation_API error");
        return error;
    }
}

export const improveText_API = async (body) => {
    try {
        const response = await axiosInstance({
            url: MAIN_URL.url + REQUEST_URL.improveText,
            method: "POST",
            data: body,
            contentType: "application/json",
            timeout: API_CONFIG.timeout
        });
        console.log(response, "improveText_API response");
        return response;
    } catch (error) {
        console.log(error, "improveText_API error");
        return error;
    }
}